module.exports = {
    get: function(key) {
        let policy = JSON.parse(window.localStorage.getItem("policy"));
        return policy[key];
    },

    cachePolicy: function(policy) {
        this.clearPolicyCache();
        window.localStorage.setItem('policy', JSON.stringify(policy));
    },

    cachePolicyError: function(error) {
        this.clearPolicyCache();
        window.localStorage.setItem('policy_error', error);
    },

    clearPolicyCache: function() {
        window.localStorage.removeItem("policy");
    },
};



/** WEBPACK FOOTER **
 ** ./src/components/Managers/Policy.js
 **/